import { Work } from '@skinsoft/types'
import { dbCacheDown } from '../dexie/cache-down'
import { STATS_KEYS } from '../dexie/stats-keys'
import { OfflineDataFetcher } from '@skinsoft/offline'


export class WorkOfflineDataFetcher extends OfflineDataFetcher<Work>{

    constructor() {
        super(dbCacheDown.work, STATS_KEYS.work)
    }

    /*public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }*/

    protected idMatcher(entity: any, id: string) {
        if (entity.work) {
            return entity.work.id === id;
        }
        return false;
    }

}